import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../../../../../core/services/common.service';
import {Message} from '../../../../../../../core/class/message';
import {EnumContractEnterpriseStatus} from '../../../../../../../core/constants/contract';

@Component({
  selector: 'app-sign-flow-lot-list',
  templateUrl: './sign-flow-lot-list.component.html',
  styleUrls: ['./sign-flow-lot-list.component.scss']
})
export class SignFlowLotListComponent {
  /** Các HĐ/VB thỏa mãn điều kiện thiết lập luồng (được tiếp tục thiết lập). */
  contracts: any[] = [];
  noOfFiles: number = 0;
  notifyWarning: string = '';

  displayedColumns: string[] = ['STT', 'contractName', 'createdEnterpriseName', 'receivedTime'];

  constructor(
    public dialogRef: MatDialogRef<SignFlowLotListComponent>,
    private message: Message,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const selectedRows: any[] = (data && data.contracts) || [];
    dialogRef.disableClose = true;

    const validData = selectedRows.filter(item =>
      item.status === EnumContractEnterpriseStatus.PROCESSING
      && item.progressStatus === EnumContractEnterpriseStatus.WAIT_SETUP_FLOW
    );
    const notSatisfied = selectedRows.length - validData.length;

    this.contracts = validData;
    this.noOfFiles = this.contracts.reduce(function (s, a) {
      return s + (a.contractAttachments ? a.contractAttachments.length : 0);
    }, 0);

    if (notSatisfied > 0) {
      this.notifyWarning = this.commonService.format(
        this.message.getMessage('messages.warning_multi_setup_flow_lot'),
        selectedRows.length, notSatisfied, validData.length
      );
    } else {
      this.notifyWarning = '';
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onContinue() {
    this.dialogRef.close(this.contracts);
  }
}
